export const taxonomyLevel2Values = [
  'Activity & entertainment',
  'Amazon device accessories',
  'Arts & photography',
  'Automotive enthusiast merchandise',
  'Baby care',
  'Baby stationery',
  'Beading & jewelry making',
  'Biographies & memoirs',
  'Business & money',
  'Calendars',
  'Car care',
  'Car seats & accessories',
  "Children's books",
  'Christian books & bibles',
  'Comics & graphic novels',
  'Computers & technology',
  'Cookbooks, food & wine',
  'Crafting',
  'Crafts, hobbies & home',
  'Diapering',
  'Dishwashers',
  'Education & teaching',
  'Exterior accessories',
  'Fabric',
  'Fabric decorating',
  'Feeding',
  'Foot, hand & nail care',
  'Fragrance',
  'Garbage disposals & compactors',
  'Gifts',
  'Hair care',
  'Health, fitness & dieting',
  'History',
  'Humor & entertainment',
  'Interior accessories',
  'Knitting & crochet',
  'Law',
  'Lesbian, gay, bisexual & transgender books',
  'Lights & lighting accessories',
  'Literature & fiction',
  'Makeup',
  'Medical books',
  'Motorcycle & powersports',
  'Mystery, thriller & suspense',
  'Needlework',
  'New, used & rental textbooks',
  'Nursery',
  'Oils & fluids',
  'Oral care',
  'Organization, storage & transport',
  'Painting, drawing & art supplies',
  'Parenting & relationships',
  'Parts & accessories',
  'Politics & social sciences',
  'Potty training',
  'Pregnancy & maternity',
  'Printmaking',
  'Ranges, ovens & cooktops',
  'Reference',
  'Refrigerators, freezers & ice makers',
  'Religion & spirituality',
  'Replacement parts',
  'Romance',
  'Rv parts & accessories',
  'Safety',
  'Science & math',
  'Science fiction & fantasy',
  'Scrapbooking & stamping',
  'Self-help',
  'Sewing',
  'Shave & hair removal',
  'Skin care',
  'Sports & outdoors',
  'Strollers & accessories',
  'Teen & young adult',
  'Tires & wheels',
  'Tools & accessories',
  'Tools & equipment',
  'Travel'
];
